import { User } from "../redux/types/userTypes";

export function accountEndpoint(action: string): string {
  const configured = process.env.REACT_APP_AUTH_API_BASE_URL;
  try {
    if (!configured) throw new Error();
    const url = new URL(configured);
    if (
      url.protocol !== "https:" ||
      url.username ||
      url.password ||
      url.pathname !== "/" ||
      url.search ||
      url.hash
    )
      throw new Error();
    return `${url.origin}/app/api/auth/${action}`;
  } catch {
    throw new Error(
      "The secure account service is not configured. Please contact the staging administrator.",
    );
  }
}

export async function accountRequest(
  action: string,
  data: Record<string, string>,
): Promise<{ users: User[]; notice?: string }> {
  const endpoint = accountEndpoint(action);
  if (!data.captchaToken)
    throw new Error("Please complete CAPTCHA verification.");
  let response: Response;
  try {
    response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      credentials: "omit",
      redirect: "error",
    });
  } catch {
    throw new Error(
      "The secure account service is unavailable. Please try again later.",
    );
  }
  const result = await response.json();
  if (!response.ok)
    throw new Error(
      typeof result.message === "string"
        ? result.message
        : "Account request failed. Please try again.",
    );
  if (!Array.isArray(result.users))
    throw new Error("Invalid account service response.");
  return result;
}
